import { render, staticRenderFns } from "./LmPeopleTypesNewOrEdit.vue?vue&type=template&id=3b3805ed&"
import script from "./LmPeopleTypesNewOrEdit.vue?vue&type=script&lang=js&"
export * from "./LmPeopleTypesNewOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./LmPeopleTypesNewOrEdit.vue?vue&type=style&index=0&id=3b3805ed&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports